/*eslint-disable*/
import MDBox from "components/MDBox";

import { Bounce } from "react-activity";
import "react-activity/dist/react-activity.css";

export default function Activity() {
	return (
		<MDBox width="100%" py={1}>
			<Bounce />
		</MDBox>
	);
}
